import {
    GET_PENDINGSKULOOKUP_REPORT_REQUEST,
    GET_PENDINGSKULOOKUP_REPORT_SUCCESS,
    GET_PENDINGSKULOOKUP_REPORT_ERROR,
  } from "../actions/types";
  
  export const getPendingSKULookUpReport = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case   GET_PENDINGSKULOOKUP_REPORT_REQUEST:
        return {
          loading: true,
        };
      case   GET_PENDINGSKULOOKUP_REPORT_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case   GET_PENDINGSKULOOKUP_REPORT_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  